import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { setRulesPopUp } from "../../store/rulesPopUp/rulesPopUp.slice";
import { createPortal } from "react-dom";
import { rulesPage } from "../../constants/rulesRegulationsData";
import SVG_CloseDarkIcon from "../../assets/images/svgs/close-dark.svg?react";
import SVG_ArrowIcon from "../../assets/images/svgs/rules-arrow.svg?react";
import { UNICON_THEME } from "../../config/api.config";
const modalRoot = document.querySelector("#modal-root");

const RulesPopUpSportEvents = ({ open }) => {
  const genRuleRef = useRef(null);
  const fancyRuleRef = useRef(null);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [showFancy, setShowFancy] = useState(false);

  const handleToggle = () => {
    setShow(!show);
  };
  const handleToggleFancy = () => {
    setShowFancy(!showFancy);
  };

  return createPortal(
    <>
      {open && (
        <div
          id="popup-modal"
          onClick={() => dispatch(setRulesPopUp(false))} // Close on outside click
          className="z-[1000] absolute top-0 right-[0.5px] md:right-0 overflow-hidden flex w-full h-screen min-h-[100dvh] items-center justify-center bg-bg_CasinoPopupBg"
        >
          <div
            onClick={(e) => e.stopPropagation()} // Prevent close on inner click
            className="z-2 popUpBoxShadow popUpOpenAnimation absolute bg-bg_Quaternary w-[90%] h-[60%] max-w-[500px] flex justify-center overflow-y-auto p-2 xs:p-5 rounded-md"
          >
            <div
              className="transition-all mb-2 ease-in-out duration-200 hover:scale-105 absolute top-2 right-2 cursor-pointer"
              onClick={() => dispatch(setRulesPopUp(false))}
            >
              <SVG_CloseDarkIcon />
            </div>

            <div className="bg-light overflow-y-auto no-scrollbar">
              <div className="h-full overflow-auto">
                <div className="flex p-3 justify-center flex-col border-b">
                  <div
                    className={`flex items-center gap-2 text-xl ${UNICON_THEME?"":"text-white"}`}
                    onClick={() => handleToggle()}
                  >
                    <span className="ml-2 transform-all ease-in-out duration-500">
                      <SVG_ArrowIcon />
                    </span>
                    {rulesPage[0]?.title}
                  </div>

                  <div
                    className="w-full font-lato text-sm px-4 overflow-hidden text-justify conte duration-500 ease-in-out"
                    style={{
                      height: show
                        ? genRuleRef.current
                          ? genRuleRef.current.offsetHeight
                          : 0
                        : 0,
                    }}
                  >
                    <div ref={genRuleRef} className={`${UNICON_THEME?"":"text-white"}`}>{rulesPage[0]?.rules}</div>
                  </div>
                </div>
                <div className="flex p-3 justify-center flex-col border-b">
                  <div
                    className={`flex items-center gap-2 text-xl ${UNICON_THEME?"":"text-white"}`}
                    onClick={() => handleToggleFancy()}
                  >
                    <span className="ml-2 transform-all ease-in-out duration-500">
                      <SVG_ArrowIcon />
                    </span>
                    {rulesPage[1]?.title}
                  </div>

                  <div
                    className="w-full font-lato text-sm px-4 overflow-hidden text-justify conte duration-500 ease-in-out"
                    style={{
                      height: showFancy
                        ? fancyRuleRef.current
                          ? fancyRuleRef.current.offsetHeight
                          : 0
                        : 0,
                    }}
                  >
                    <div ref={fancyRuleRef} className={`${UNICON_THEME?"":"text-white"}`}>{rulesPage[1]?.rules}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>,
    modalRoot
  );
};

export default RulesPopUpSportEvents;
